import { render, staticRenderFns } from "./WalletStakeNoticeModal.vue?vue&type=template&id=0f9c1e3e&"
import script from "./WalletStakeNoticeModal.vue?vue&type=script&lang=js&"
export * from "./WalletStakeNoticeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports